<template>
  <v-card class="pa-3" outlined style="border-radius: 6px; height: 100%">
    <div class="pa-2 grey lighten-2" style="border-radius: 6px">
      <strong>{{ $t('Corretivas abertas há mais de') }}</strong>

      <div class="mt-2 d-flex">
        <v-btn
          small
          @click=";(filter.startDays = 0), list()"
          class="primary-button"
          :color="filter.startDays == 0 ? 'primary' : 'white'"
          depressed
        >
          30 {{ $t('dias') }}
        </v-btn>
        <v-btn
          small
          @click=";(filter.startDays = 1), list()"
          class="primary-button"
          :color="filter.startDays == 1 ? 'primary' : 'white'"
          depressed
        >
          60 {{ $t('dias') }}
        </v-btn>
        <v-btn
          small
          @click=";(filter.startDays = 2), list()"
          class="primary-button"
          :color="filter.startDays == 2 ? 'primary' : 'white'"
          depressed
        >
          90 {{ $t('dias') }}
        </v-btn>
      </div>
    </div>

    <h3 class="ma-2">
      {{ $t('Porcentagem') }}:
      {{
        data.filteredPercentage ? data.filteredPercentage.toFixed(2) : '0.00'
      }}%
    </h3>
    <BarChart :chart-data="chartData" :options="options" />
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import BarChart from '../../Reports/components/charts/pieChart'

export default {
  name: 'ScheduleComponent',

  props: {
    unidadeIds: Array,
    departmentIds: Array,
    institutionIds: Array,
  },

  watch: {
    unidadeIds() {
      this.filter.unidadeIds = this.unidadeIds
    },
    departmentIds() {
      this.filter.departmentIds = this.departmentIds
    },
    institutionIds() {
      this.filter.institutionIds = this.institutionIds
    },
  },

  components: {
    BarChart,
  },

  data() {
    return {
      options: {
        legend: {
          display: false,
        },
      },
      apiService: new ApiService(),
      filter: {
        startDays: 0,
        page: 1,
        pageSize: 10,
        unidadeIds: [],
        departmentIds: [],
        institutionIds: [],
        institutionId: 1,
      },
      chartData: {},
      data: {
        dataByMonth: [],
      },
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    list() {
      this.apiService
        .post('dash/schedule-corrective', this.filter)
        .then((response) => {
          this.data = response.content
          this.chartData = {
            labels: ['Total', 'Abertas há mais de 30 dias'],
            datasets: [
              {
                label: 'Corretivas',
                data: [this.data.total, this.data.filtered],
                backgroundColor: ['#0F3565', '#B9CE1E'],
                pointRadius: 5,
                pointHoverRadius: 10,
              },
            ],
          }

          if (this.filter.startDays == 1) {
            this.chartData.labels[1] = 'Abertas há mais de 60 dias'
          }

          if (this.filter.startDays == 2) {
            this.chartData.labels[1] = 'Abertas há mais de 90 dias'
          }
        })
    },
  },
}
</script>

<style scoped></style>
